import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import LoadingSpinner from 'components/layouts/LoadingSpinner/LoadingSpinner';

export const ConfigContext = React.createContext({});

const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({});

  const loadConfig = async () => {
    const envResponse = await fetch(`${process.env.REACT_APP_CONTEXT_PATH}config.json`);
    const configResponse = await fetch(`${process.env.REACT_APP_CONTEXT_PATH}config.json`);
    const envConfig = await envResponse.json();
    const config = await configResponse.json();
    const mergedConfig = {
      ...config,
      ...envConfig,
    };
    window.config = {};
    window.config = mergedConfig;
    setConfig(mergedConfig);
  };

  useEffect(() => {
    loadConfig();
  }, []);


  return !isEmpty(config)
    ? <ConfigContext.Provider value={{ config }}>
        {children}
      </ConfigContext.Provider>
    : <div>
        <LoadingSpinner name="Life Events..."/>
      </div>;
};


export default ConfigProvider;
